const baseUrl = 'https://leo-edge.top';
module.exports = {
  domain: baseUrl,
  domain1: baseUrl,
  domain2: baseUrl,
  imgDomain: baseUrl,
}



// WEBPACK FOOTER //
// ./src/utils/url.js